/* ==================================================================
   OSKIN CAROUSEL ARROWS — auto-inject flechas en todos los carruseles
   Se ejecuta en mobile (≤ 768px) y agrega flechas prev/next a:
   .offers-grid, .tech-grid, .cat-grid, .testi-grid
   ================================================================== */
(function () {
  var CAROUSEL_SELECTORS = [
    '.offers-grid',
    '.tech-grid',
    '.cat-grid',
    '.testi-grid'
  ];
 
  function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }
 
  function buildArrows() {
    var wrap = document.createElement('div');
    wrap.className = 'oskin-carousel-arrows';
    wrap.innerHTML =
      '<button type="button" class="osk-arrow osk-arrow-prev" aria-label="Anterior">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg>' +
      '</button>' +
      '<button type="button" class="osk-arrow osk-arrow-next" aria-label="Siguiente">' +
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg>' +
      '</button>';
    return wrap;
  }
 
  function setupCarousel(track) {
    if (track.dataset.oskCarousel === '1') return;
    track.dataset.oskCarousel = '1';
 
    var arrowsEl = buildArrows();
    if (track.parentNode) {
      track.parentNode.insertBefore(arrowsEl, track.nextSibling);
    }
 
    var prev = arrowsEl.querySelector('.osk-arrow-prev');
    var next = arrowsEl.querySelector('.osk-arrow-next');
    if (!prev || !next) return;
 
    function step() {
      var card = track.querySelector(':scope > a, :scope > .offer-card, :scope > .tech-card, :scope > .cat-card, :scope > .testi-card, :scope > div, :scope > article');
      if (!card) {
        var first = track.firstElementChild;
        if (!first) return 320;
        return first.getBoundingClientRect().width;
      }
      return card.getBoundingClientRect().width;
    }
 
    prev.addEventListener('click', function (e) {
      e.preventDefault();
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function (e) {
      e.preventDefault();
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
 
    function update() {
      var max = track.scrollWidth - track.clientWidth - 4;
      prev.classList.toggle('is-disabled', track.scrollLeft <= 4);
      next.classList.toggle('is-disabled', track.scrollLeft >= max);
    }
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    setTimeout(update, 100);
  }
 
  function teardownCarousel(track) {
    if (track.dataset.oskCarousel !== '1') return;
    track.dataset.oskCarousel = '0';
    var sibling = track.nextElementSibling;
    if (sibling && sibling.classList && sibling.classList.contains('oskin-carousel-arrows')) {
      sibling.parentNode.removeChild(sibling);
    }
  }
 
  function init() {
    var mobile = isMobile();
    CAROUSEL_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (track) {
        if (mobile) {
          setupCarousel(track);
        } else {
          teardownCarousel(track);
        }
      });
    });
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('resize', function () {
    clearTimeout(window.__oskCarouselT);
    window.__oskCarouselT = setTimeout(init, 200);
  });
})();